import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "@/lib/firebase";

export async function publishUserHeatPing(
  lat: number,
  lng: number,
  source: "login" | "settings" | "widget" | "manual" | "update" = "update"
) {
  const uid = getAuth().currentUser?.uid;
  if (!uid) return; // require auth
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

  // light rounding keeps docs tidy; CF uses precise bucket anyway
  const r6 = (n: number) => Math.round(n * 1e6) / 1e6;

  await addDoc(collection(db, "user_locations", uid, "points"), {
    lat: r6(lat),
    lng: r6(lng),
    source,
    created: serverTimestamp(),
  });
}
